import React, { PropsWithChildren, useContext } from 'react'
import { observer } from 'mobx-react'
import { StoresContext } from '@App/contexts'
import { Navigate } from 'react-router'

interface PermissionCheckProps {
    requiredPermissions: string[]
    orIsInternal?: boolean
    reRouteLocation?: string
    bypassRestriction?: boolean
}

const PermissionCheck = (props: PropsWithChildren<PermissionCheckProps>) => {
    const { rightsholderUserStore, rightsholderStore } = useContext(StoresContext)
    const { requiredPermissions, children, orIsInternal, reRouteLocation, bypassRestriction } = props
    const userHasPermission = orIsInternal
        ? rightsholderUserStore.doesRHUserHaveOneOfThesePermissionOrIsInternal(requiredPermissions)
        : rightsholderUserStore.doesRHUserHaveOneOfThesePermission(requiredPermissions)
    const isRestricted = rightsholderStore.isRestricted && !bypassRestriction

    const allowRender = () => userHasPermission && !isRestricted
    if (allowRender()) {
        return <>{children}</>
    } else {
        if (reRouteLocation) {
            return <Navigate replace to={reRouteLocation} />
        }
        return <></>
    }
}

export default observer(PermissionCheck)
